module.exports = __webpack_public_path__ + "static/media/capital_gains_icon.d19b7609.svg";